import { HTTPServiceClient } from '@/packages/http/service';
import * as t from './endpoints';
import Organisation from '@/models/Organisation';
import OrganisationType from '@/models/OrganisationType';
import User from '@/models/User';
import { UpdateUserSettingsRequest, Google2faDetails } from './types';

/**
 * --------------------------------------------------
 *	Dashboard HTTP Serice
 * --------------------------------------------------
 **/
export const DashboardService = {
  /**
   * Fetches all organisations
   * @returns {Promise<Organisation[]>} Organisations
   */
  getOrganisations(): Promise<Organisation[]> {
    return HTTPServiceClient.get(t.ORGANIZATIONS(), {
      params: { include: 'organizationType' }
    }).then(({ data }) => data.data);
  },

  /**
   * Fetches all organisation types
   * @returns {Promise<OrganisationType[]>} Organisation Types
   */
  getOrganisationTypes(): Promise<OrganisationType[]> {
    return HTTPServiceClient.get(t.GET_ORGANISATION_TYPES).then(
      ({ data }) => data.data
    );
  },

  /**
   * Fetches the logged in user
   * @returns {Promise<User>}
   */
  async fetchCurrentUser(): Promise<User> {
    const { data } = await HTTPServiceClient.get(t.FETCH_USER_ENDPOINT);
    return data.data;
  },

  /**
   * Fetches the logged in user
   * @returns {Promise<User>}
   */
  async editUserDetails(params: UpdateUserSettingsRequest): Promise<User> {
    const { data } = await HTTPServiceClient.patch(
      t.EDIT_USER_ENDPOINT(`${params.userId}`),
      params
    );
    return data.data;
  },

  /**
   * Setup Google 2fa
   * @returns {Promise<Google2faResponse>}
   */
  async setupGoogle2fa(userId: string): Promise<Google2faDetails> {
    const { data } = await HTTPServiceClient.post(
      t.SETUP_GOOGLE2FA_ENDPOINT(userId)
    );
    return data;
  }
};
